import { Trash2 } from "lucide-react";
import { thumb, API } from "../../lib/api";
import LoadMore from "../../components/LoadMore";

export default function AdminMedia({ ctx }) {
  const { media, copyMediaUrl, deleteMedia } = ctx;
  return (
    <div className="mt-10" data-testid="admin-media">
      <p className="text-[#121212]/70 text-sm mb-6">Everything you've uploaded. Copy a URL to reuse an image or video anywhere, or remove files you no longer need.</p>
      {media.length === 0 ? <p className="text-[#121212]/60">No uploads yet.</p> : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {media.map((m) => {
            const url = `${API}/files/${m.storage_path}`;
            const isVideo = (m.content_type || "").startsWith("video/");
            return (
              <div key={m.id} data-testid={`media-${m.id}`} className="bg-white border-2 border-[#121212] flex flex-col">
                <div className="aspect-square overflow-hidden bg-stone-100 flex items-center justify-center">
                  {isVideo ? <video src={url} className="w-full h-full object-cover" muted /> : <img src={thumb(url, 300)} alt={m.original_filename} className="w-full h-full object-cover" />}
                </div>
                <div className="p-3 flex-1 flex flex-col">
                  <p className="text-xs text-[#121212] truncate font-medium">{m.original_filename || "file"}</p>
                  <p className="text-[10px] text-[#121212]/50 uppercase tracking-wider mt-0.5">{isVideo ? "Video" : "Image"} · {Math.round((m.size || 0) / 1024)}KB</p>
                  <div className="mt-3 flex gap-2">
                    <button data-testid={`media-copy-${m.id}`} onClick={() => copyMediaUrl(m.storage_path)} className="flex-1 px-2 py-1.5 bg-[#121212] text-[#F2E9D8] hover:bg-black text-[10px] tracking-[0.1em] uppercase font-bold">Copy URL</button>
                    <button data-testid={`media-delete-${m.id}`} onClick={() => deleteMedia(m.id)} className="px-2 py-1.5 border-2 border-[#121212] hover:bg-[#FF8F80]"><Trash2 size={13} /></button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
      <LoadMore ctx={ctx} pkey="media" label="Load more uploads" />
    </div>
  );
}
